import {
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS, activityAssessmentsLegend } from '@src/modules/performance/shared/constants';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { usePlanningQuality } from '@src/modules/performance/context/reports-api-hooks';
import ReportHeader from './ReportHeader';

const subheader = 'Planning and Procurement';
const informationSource = {
  title: 'Activity Management Planning',
  content: [
    {
      title: 'Planning quality',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The result of an independent assessment by Road Efficiency Group Te Ringa Maimoa of the TA&rsquo;s Transport Activity Management Plan (AMP) submitted to NZTA.
    </Text>
    <Text fontSize="inherit" mb={2}>
      AMPs are assessed against elements of the &quot;Road Efficiency Group Te Ringa Maimoa Pillars of Success&quot; framework including Systems, Evidence, Communicating, Decision Making, Service Delivery and Improvement Plan.
    </Text>
    <Text fontSize="inherit" mb={2}>
      The assessment consists of 23 attributes scored 0 to 3. The result displayed is an average of the attribute scores.
    </Text>
    <Text fontSize="inherit" mb={2}>
      The average attribute result colour grading is as follows:
    </Text>
    <IndicatorLegend items={activityAssessmentsLegend} />
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Assessment, results and grading provided by Road Efficiency Group Te Ringa Maimoa.
  </Text>,
    },
  ],
};

function ActivityManagementReportHeader({ ...rest }) {
  const { data: planningQuality, isLoading } = usePlanningQuality();

  return (
    <ReportHeader
      title="Activity Management"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={TRAFFIC_LIGHT_COLOURS[planningQuality?.colour]}
            value={planningQuality?.value?.toFixed(2)}
            isLoading={isLoading && !planningQuality}
          />
        </Box>
        <Box pr={15}>
          <Text fontWeight="bold" color="gray" fontSize="sm" lineHeight={1.3}>
            Planning quality
            <br />
            <Text as="span" fontSize="xs" color="gray">
              out of
              {' '}
              {planningQuality?.max?.toFixed(2)}
              <br />
              (2024-27)
            </Text>
          </Text>
        </Box>
      </Flex>
    </ReportHeader>
  );
}

export default ActivityManagementReportHeader;
